import { render, staticRenderFns } from "./CheckboxGroupQuestion.vue?vue&type=template&id=3b2f58bd&scoped=true&"
import script from "./CheckboxGroupQuestion.vue?vue&type=script&lang=js&"
export * from "./CheckboxGroupQuestion.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxGroupQuestion.vue?vue&type=style&index=0&id=3b2f58bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2f58bd",
  null
  
)

export default component.exports